import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { css } from 'styled-components'
import styled, { useTheme } from 'styled-components/native'

import { BodyText, Size as BodyTextSize } from '../../atoms/bodyText/BodyText'
import { CopyToClipboard } from '../../atoms/copyToClipboard/CopyToClipboard'
import { AlertIconStroke } from '../../atoms/icons/AlertIconStroke'
import { Title, Size as TitleSize } from '../../atoms/title/Title'

export type ParentIntakeFormLinkProps = {
  parentIntakeLink?: string
  shouldDisplayParentIntakeLink?: boolean
}

const ParentIntakeFormLinkContainer = styled.View(({ theme: { spacing, colors } }) => ({
  marginTop: spacing['16px'],
  borderRadius: spacing['16px'],
  padding: spacing['16px'],
  backgroundColor: colors.backgroundElement,
  flexDirection: 'column',
}))

const HeaderContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
})

const IconContainer = styled.View(({ theme: { spacing } }) => ({
  height: '24px',
  width: '24px',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: spacing['8px'],
}))

const Content = styled.View(({ theme: { spacing } }) => ({
  marginTop: spacing['4px'],
  marginLeft: spacing['32px'],
}))

const DescriptionContainer = styled.View({
  marginBottom: '6px',
})

export const ParentIntakeFormLink: FunctionComponent<ParentIntakeFormLinkProps> = ({
  shouldDisplayParentIntakeLink,
  parentIntakeLink,
}) => {
  const { colors } = useTheme()
  return (
    <>
      {shouldDisplayParentIntakeLink && parentIntakeLink ? (
        <ParentIntakeFormLinkContainer>
          <HeaderContainer>
            <IconContainer>
              <AlertIconStroke size={20} fillColor={colors.iconDefault} />
            </IconContainer>
            <Title
              text={
                <FormattedMessage
                  defaultMessage='Parent intake'
                  description='Subheader for Parent Intake form link to display'
                />
              }
              size={TitleSize.XSMALL}
            />
          </HeaderContainer>
          <Content>
            <DescriptionContainer>
              <BodyText
                text={
                  <FormattedMessage
                    defaultMessage='This unique link is for the parent intake form. This link is for this specific episode and should not be shared with other clients.'
                    description='Description for the Parent Intake form link'
                  />
                }
                size={BodyTextSize.SMALL}
              />
            </DescriptionContainer>
            <CopyToClipboard
              displayTextSize={BodyTextSize.SMALL}
              displayText={
                <FormattedMessage
                  defaultMessage='Copy intake link'
                  description='Label for the button that copies intake link to the clipboard for parent'
                />
              }
              copyText={parentIntakeLink}
              containerCustomStyle={css`
                flex-direction: row-reverse;
                gap: 8px;
                text-decoration-line: underline;
                text-decoration-color: ${colors.textActive};
              `}
            />
          </Content>
        </ParentIntakeFormLinkContainer>
      ) : (
        <></>
      )}
    </>
  )
}
